<template>
    <v-row class="pa-0">
      <v-col cols="12">
        <v-system-bar window dark v-if="company!=null" color="cyan darken-3">
          <v-icon>house</v-icon>
          <span class="subtitle-2">Ihr Standort in <span class="font-weight-black">{{company.city}}</span></span>
          <v-spacer></v-spacer>
          <v-icon @click="close">mdi-close</v-icon>
        </v-system-bar>

        <v-row v-for="(device) in devices" :key="device.guid">
            <v-col cols="12">
                <WidgetDevice :startDevice="device" :startCompanyGuid="companyId" :pmap="pmap" :ref="device.guid" @reloadDevice="reloadDevice"></WidgetDevice>
            </v-col>
        </v-row>
      </v-col>
    </v-row>
</template>

<script>
    import WidgetDevice from "../../widgets/WidgetDevice"
    import Vue from "vue";

    export default {
        name: "MyLocation",
        components: {WidgetDevice},
        data: () => ({
            channel: null,
            pmap: [],
            channelList: [{
                id: '1',
                text: 'Berge'
            }, {
                id: '2',
                text: 'Kreuzfahrten'
            }],
            numberOfItemsCard: '15 Items',
            titleGeraete: 'Mein Gerät ...',
            playlistName: 'Name der Playlist',
            model1: null,
            dialog: false,
            value: '',
            forename: '',
            company: null,
            lastname: '',
            device: null,
            drawer: null,
            userData: '',
            isShowMenu: false,
            model: '',
            ApplicationName: 'Kermax',
            showSearch: false,
            showNotify: false,
            showApps: false,
            companyId: null,
            items: [
                {
                    icon: 'keyboard_arrow_up',
                    'icon-alt': 'keyboard_arrow_down',
                    text: 'Navigation',
                    id: '1',
                    model: 'true',
                    children: []
                }
                /* ,
                {
                  icon: 'keyboard_arrow_up',
                  'icon-alt': 'keyboard_arrow_down',
                  text: 'Admin',
                  id: '2',
                  model: 'true',
                  children: [
                    {icon: 'supervisor_account', text: 'Benutzer', url: '/Dashboard/Benutzer'}
                  ],
                } */

            ],
            companyData: null,
            devices: null,
            modules: [
                {
                    color: '#fcbf00',
                    cnt: '0',
                    visible: false,
                    title: 'Netzwerke',
                    icon: 'business'
                },
                {
                    color: '#fcbf00',
                    cnt: '0',
                    visible: false,
                    title: 'Mein Standort',
                    icon: 'house'
                },
                {
                    color: '#1B5E20',
                    cnt: '0',
                    visible: false,
                    title: 'Playlist',
                    icon: 'play_circle_outline'
                },
                {
                    color: '#E65100',
                    cnt: '0',
                    visible: false,
                    title: 'Meine Geräte',
                    icon: 'devices'
                },
                {
                    color: '#26C6DA',
                    cnt: '0',
                    visible: false,
                    title: 'Benutzer',
                    icon: 'people'
                }
            ]
        }),
        computed: {
            myItems() {
                var cmp = this
                return cmp.modules.filter(item => {
                    return item.visible
                })
            }
        },
        methods: {
            close: function () {
                this.$router.push('/Dashboard/Main')
            },
            onGetDevices: function (data) {
                this.devices = data
                for (let i in this.devices) {
                  let device = this.devices[i]
                  if (!this.pmap[device.orientation]) {
                    this.pmap[device.orientation] = []
                  }
                  this.pmap[device.orientation].push(device)
                }
                this.modules[2].cnt = data.length
            },
            onGetData: function (data) {
                this.companyData = data
                this.company = data[0]
                Vue.prototype.$api.loadDevicesFromCompany(this.companyId, this.onGetDevices)
            },
            reload: function () {
                var reqData = {
                    isMother: 1
                }
                reqData.guid = Vue.prototype.$api.getCredentials().data.guidParent

                Vue.prototype.$apiCompany.loadCompanies(reqData, this.onGetData)
            },
            reloadDevice(d) {
              try {
                let cmp = this.$refs[d.guid]
                if (cmp.length > 0)  {
                  cmp = cmp[0]
                }
                cmp.reload(d.device, d.companyGuid)
              } catch (e) {
                console.error(e)
              }
            },
        },
        mounted() {
            this.userData = Vue.prototype.$api.getCredentials().data
            this.companyId = Vue.prototype.$api.getCredentials().data.guidParent
            this.reload()
        },
        created() {
            Vue.prototype.$eventHub.$on('OnDeviceSelected', this.OnDeviceSelected)
            Vue.prototype.$eventHub.$on('OnChangeSelectedChannels', this.OnChangeSelectedChannels)

        },
        destroyed() {
            Vue.prototype.$eventHub.$off('OnDeviceSelected', this.OnDeviceSelected)
            Vue.prototype.$eventHub.$off('OnChangeSelectedChannels', this.OnChangeSelectedChannels)
        }
    }
</script>

<style scoped>

</style>
